import { useTranslation } from "react-i18next";

function Footer1() {

    const { t, i18n } = useTranslation()
    return (
        <>
                   <div className="container">
                    {/* NEWS LETTER SECTION START */}
                    {/* <div className="ftr-nw-content">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="ftr-nw-title">
                                    Join our email subscription now to get updates
                                    on new jobs and notifications.
                                </div>
                            </div>
                            <div className="col-md-7">
                                <form>
                                    <div className="ftr-nw-form">
                                        <input name="news-letter" className="form-control" placeholder="Enter Your Email" type="text" />
                                        <button className="ftr-nw-subcribe-btn">Subscribe Now</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> */}
                    {/* NEWS LETTER SECTION END */}
                    
                    {/* FOOTER COPYRIGHT */}
                    <div style={{width:"100%",textAlign:"center"}}>
                                <span className="copyrights-text">{t("general.copyright")}</span>
                            </div>
                            {/* <ul className="social-icons">
                                <li><a href="https://www.facebook.com/" className="fab fa-facebook-f" /></li>
                                <li><a href="https://www.twitter.com/" className="fab fa-twitter" /></li>
                                <li><a href="https://www.instagram.com/" className="fab fa-instagram" /></li>
                                <li><a href="https://www.youtube.com/" className="fab fa-youtube" /></li>
                            </ul> */}
                        </div>
        </>
    )
}

export default Footer1;